export const Steps = [
  {
    tittle: "first-steps",
    disableBeacon: "true",
    content:
      "Here you can view total time spent exercising, total exercises performed, and your streak count.",
    target: "#user-details-header",
    placement: "top",
    styles: {
      options: {
        width: 420,
        outerHeight: 180,
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
        fontWeight: "100",
        fontSize: "8",
        fontFamily: "open-sans",
      },
    },
  },
  {
    tittle: "second-step",
    disableBeacon: "true",
    content:
      "Here you can search for different programs, routines and exercises.",
    target: "#hamburger-menu",
    placement: "top",
    styles: {
      options: {
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
      },
    },
  },
  {
    tittle: "third-step",
    disableBeacon: "true",
    content: "Here you can access your profile, see your overall performance.",
    target: "#profile-header",
    placement: "top",
    styles: {
      options: {
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
      },
    },
  },
  // {
  //   tittle: "fourth-step",
  //   disableBeacon: "true",
  //   content: "Here you can contact to our coach to resolve your query.",
  //   target: "#call-a-coach",
  //   position: 'top', // Set the position to 'top' to display the information box above the feature
  //   styles: {
  //     options: {
  //       width: 420,
  //       outerHeight: 180,
  //       arrowColor: "white",
  //       backgroundColor: "#0E0E11",
  //       primaryColor: "#0E0E11",
  //       textColor: "white",
  //       fontWeight: "100",
  //       fontSize: "8",
  //       fontFamily: "open-sans",
  //     },
  //   },
  // },
  // {
  //   tittle: "fifth-steps",
  //   disableBeacon: "true",
  //   content: "Here you can schedule your workouts for later.",
  //   target: "#schedule-workout",
  //   position: 'top', // Set the position to 'top' to display the information box above the feature
  //   styles: {
  //     options: {
  //       width: 420,
  //       outerHeight: 180,
  //       arrowColor: "white",
  //       backgroundColor: "#0E0E11",
  //       primaryColor: "#0E0E11",
  //       textColor: "white",
  //       fontWeight: "100",
  //       fontSize: "8",
  //       fontFamily: "open-sans",
  //     },
  //   },
  // },
  {
    tittle: "sixth-step",
    disableBeacon: "true",
    content:
      "Here you can create your own customised program according to your goals.",
    target: "#get-customise-program",
    placement: "top",
    styles: {
      options: {
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
      },
    },
  },
  {
    tittle: "seventh-step",
    disableBeacon: "true",
    content: "Here you can perform most suited workouts for your body type",
    // target: "#top-exercises",
    target: "#mostSuitedWorkouts",
    placement: "top",
    styles: {
      options: {
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
      },
    },
  },
  {
    tittle: "eight-step",
    disableBeacon: "true",
    content: "Here you can perform recommended five days workout plan.",
    // target: "#get-customise-program",
    target: "#recommendedFiveWorkouts",
    placement: "top",
    styles: {
      options: {
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
      },
    },
  },
  {
    tittle: "nineth-step",
    disableBeacon: "true",
    content: "Here you can perform recommended AI workouts.",
    // target: "#get-customise-program",
    target: "#recommendedAIWorkouts",
    placement: "top",
    styles: {
      options: {
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
      },
    },
  },
  {
    tittle: "tenth-step",
    disableBeacon: "true",
    content: "Here you can perform exercise with AI posture correction.",
    target: "#top-exercises",
    // target: "#top-routines",
    placement: "top",
    styles: {
      options: {
        arrowColor: "white",
        backgroundColor: "#0E0E11",
        primaryColor: "#0E0E11",
        textColor: "white",
      },
    },
  },
];
